import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { ButtonItem, SegmentedItem, TableItemDinamico, HeaderActions } from "../../../Components/Items";
import { connect } from "react-redux";
import { StopOutlined, EditOutlined, CheckCircleOutlined, ImportOutlined, ExportOutlined, SafetyCertificateOutlined, SettingOutlined, TableOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx'
import moment from "moment";
  import "moment/locale/es";
  moment.locale("es");
class Clientes extends Component {
  tableRef = null;
  state = {
    todasClientes: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
  }

  consultarClientes(params) {
    this.setState({ loading: true })
    axios
      .post(
        "clientes/selectTodosClientes",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasClientes: res.data.data,
            totalRecords: res.data.totalRecords || 0,
            loading: false
          });
        } else {
          this.setState({ todasClientes: [], totalRecords: 0, loading: false });
        }
      });
  }
  agregarCliente() {
    this.props.history.push('/panel/agregarCliente')
  }
  importarClientes() {
    this.props.history.push('/panel/importarClientes')
  }
  edicionMasivaClientes() {
    this.props.history.push('/panel/edicionMasivaClientes')
  }
  exportarClientes() {
    this.setState({ loading: true });

    axios
      .post(
        "clientes/exportarClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });

        if (res.data.status === 404) {
          message.error("No se encontraron datos para exportar");
        } else {
          // Preparar datos de clientes
          const datosClientes = res.data.data.map(cliente => ({
            "Código": cliente.codigo,
            "Clave": cliente.clave,
            "Razón Social": cliente.razonSocial,
            "Nombre Persona Física": cliente.nombre,
            "Apellido Paterno": cliente.apellidoPaterno,
            "Apellido Materno": cliente.apellidoMaterno,
            "Nombre Comercial": cliente.nombreComercial,
            "Celular": cliente.celular,
            "CURP": cliente.curp,
            "RFC": cliente.rfc,
            "Teléfono Empresa": cliente.telefono,
            "Correo Empresa": cliente.correo,
            "Observaciones": cliente.observaciones,
            "Código Proveedor": cliente.codigoProveedor,
            "Tipo de Cliente": cliente.tipoClienteText,
            "Regimen Fiscal": cliente.regimenFiscalText,
            "Uso de CFDI": cliente.usoDeCFDIText,
            "Vendedor": cliente.vendedorText,
            "Canal": cliente.canalVentaText,
            "Precio Contado": cliente.precioContadoText,
            "Precio Crédito": cliente.precioCreditoText,
            "Metodo de Pago": cliente.metodoDePagoText,
            "Dias de Crédito": cliente.diasCredito,
            "Limite de Crédito": cliente.limiteCredito,
            "Descuento Max": cliente.limiteDescuento,
            "Nombre Contacto": cliente.nombreContacto,
            "Teléfono Contacto": cliente.telefonoContacto,
            "Correo Contacto": cliente.correoContacto,
            "Página Web": cliente.paginaWeb,
            "Código Postal": cliente.cp,
            "Colonia": cliente.coloniaText,
            "Calle": cliente.calle,
            "Número": cliente.numeroCalle,
            "Número Int": cliente.numeroInterior,
            "Fecha de Alta" :  moment(cliente.createdAt).format("DD/MM/YYYY"),
          }));

          // Crear la hoja de Excel
          const ws = XLSX.utils.json_to_sheet(datosClientes);

          // Aplicar estilos al encabezado
          const encabezados = Object.keys(datosClientes[0]);

          ws["!cols"] = encabezados.map(() => ({ wch: 20 })); // Ajustar ancho de columnas


          // Crear el libro de Excel
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Clientes");

          // Exportar archivo Excel
          XLSX.writeFile(wb, "clientes.xlsx");
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        message.error("Ocurrió un error al generar el archivo");
      });
  }

  editarCliente(id) {
    this.props.history.push('/panel/editarCliente', { id })
  }
  deshabilitarCliente(value) {
    axios
      .post(
        "clientes/deshabilitarCliente",
        { clienteId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Cliente deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }
  validarDatosClienteSAT(clienteId) {
    this.setState({ loading: true });
    axios
      .post(
        "clientes/validarDatosClienteSAT",
        { clienteId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 1) {
          if (res.data.datosValidos) {
            message.success(res.data.mensaje || "Los datos del receptor son correctos en el SAT", 8);
          } else {
            message.warning(res.data.mensaje || "El nombre del receptor no coincide con el RFC registrado en el SAT", 8);
          }
        } else {
          message.error(res.data.message || "Error al validar datos en el SAT", 8);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al validar datos en el SAT", 8);
      });
  }
  habilitarCliente(value) {
    axios
      .post(
        "clientes/habilitarCliente",
        { clienteId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Cliente habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }
  render() {
    const columns = [
      {
        title: "Codigo",
        dataIndex: "codigo",
        responsive: ["md"],
        key: "codigo",
        sorter: true,
        buscar: "codigo",
        width: 100,
      },
      {
        title: "Clave",
        dataIndex: "clave",
        responsive: ["md"],
        key: "clave",
        sorter: true,
        buscar: "clave",
        width: 90,
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: true,
        buscar: "nombre",
      },
      {
        title: "Nombre Comercial",
        dataIndex: "nombreComercial",
        responsive: ["md"],
        key: "nombreComercial",
        sorter: true,
        buscar: "nombreComercial",
        ellipsis: true,
      },
      {
        title: "RFC",
        dataIndex: "rfc",
        key: "rfc",
        sorter: true,
        buscar: "rfc",
        width: 150,
      },
      {
        title: "Dir. Fact",
        dataIndex: "direccionPrincipal",
        responsive: ["lg"],
        key: "direccionFacturacion",
        render: (dir) => {
          if (!dir || Object.keys(dir).length === 0) return "-";

          const calleNum = [dir.calle, dir.numeroCalle]
            .filter(Boolean)
            .join(" ");

          const interior = dir.numeroInterior ? `Int. ${dir.numeroInterior}` : "";

          const coloniaNombre = dir.colonia?.nombre || "";
          const cp = dir.colonia?.cp || "";

          // arma partes con existencia, sin comas fantasmas
          const partes = [
            [calleNum, interior].filter(Boolean).join(" ").trim(),
            coloniaNombre,
            cp ? `CP ${cp}` : "",
            dir.estadoText || "",
          ].filter((x) => x && x.trim());

          return <>{partes.join(", ")}</>;
        },
        ellipsis: true,
      },
      {
        title: "Tipo de Cliente",
        dataIndex: "tipoCliente",
        responsive: ["md"],
        key: "tipoCliente",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value) => {
          let buttons = [];

          const puedeEditar = this.props.permisoEditarCliente;
          buttons.push(
            <Tooltip title={puedeEditar ? "Editar Cliente" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => puedeEditar && this.editarCliente(value._id)}
                disabled={!puedeEditar}
              >
              </ButtonItem>
            </Tooltip>
          );

          buttons.push(
            <Tooltip title="Validar datos en el SAT" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                azul
                icon={<SafetyCertificateOutlined />}
                onClick={() => this.validarDatosClienteSAT(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (this.props.permisoDeshabilitarCliente) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  title="Seguro que quieres deshabilitar este cliente"
                  onConfirm={() => this.deshabilitarCliente(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar Cliente" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  title="Seguro que quieres habilitar este cliente"
                  onConfirm={() => this.habilitarCliente(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar Cliente" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Clientes"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>       
              {window.innerWidth > 1000 &&
                <>
                  <SegmentedItem
                    options={[{ label: 'Activo', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 3 }]}
                    onChange={(value) => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ valor: value });
                      }
                      this.setState({ valor: value })
                    }}
                    value={this.state.valor}
                  />
                  <div className="header-divider"></div>
                </>
              }
              <HeaderActions>
                {this.props.permisoAgregarCliente && (
                  <ButtonItem
                    type="primary"
                    azul
                    icon={<ImportOutlined />}
                    onClick={this.importarClientes.bind(this)}
                  >
                    Importar Clientes
                  </ButtonItem>
                )}
                {this.props.permisoAgregarCliente && (
                  <ButtonItem
                    type="primary"
                    cyan
                    icon={<ExportOutlined />}
                    onClick={this.exportarClientes.bind(this)}
                  >
                    Exportar Clientes
                  </ButtonItem>
                )}
                {this.props.permisoEditarCliente && (
                  <ButtonItem
                    type="default"
                    verde
                    icon={<TableOutlined />}
                    onClick={this.edicionMasivaClientes.bind(this)}
                  >
                    Edición Masiva
                  </ButtonItem>
                )}
                {this.props.permisoAccesoConfiguracionClientes && (
                  <ButtonItem
                    type="primary"
                    gris
                    icon={<SettingOutlined />}
                    onClick={() => this.props.history.push('/panel/configuracionClientes')}
                  >
                    Configuración
                  </ButtonItem>
                )}
              </HeaderActions>

              {this.props.permisoAgregarCliente &&
                <ButtonItem
                  type="primary"
                  olivo
                  onClick={this.agregarCliente.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Cliente
                </ButtonItem>
              }
            </div>
          }
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarClientes.bind(this)}
          loading={this.state.loading}
          size='small'
          dataSource={this.state.todasClientes}
          columns={columns}
          estadosLeyenda={[
            { color: 'rgba(180, 130, 255, 0.6)', label: 'Cliente Ecommerce', key: 'cliente-ecommerce' },
          ]}
          onRow={(record) => ({
            onDoubleClick: () => this.editarCliente(record._id),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
          filterStorageKey={"clientesFiltrosTabla" + this.props.empresaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarCliente: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cd44bf30e81b54183cf88")?.activado,
    permisoEditarCliente: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cd47cf30e81b54183cf89")?.activado,
    permisoDeshabilitarCliente: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ce419f30e81b54183cfb1")?.activado,
    permisoAccesoConfiguracionClientes: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a4595a1d14cbe49dcfc6283")?.activado,
  };
};

export default connect(mapStateToProps)(Clientes);
